import React from 'react';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Container from 'components/Container';

const mock = [
  {
    name: 'Curriculum offerings',
    email: '',
    
  },
  {
    name: '',
    email: 'Pre-Primay – Montessori or Kindergarten',
    
  },
  {
    name: '	',
    email: 'Classes 1 – 12 – CBSE Curriculum ',
  
  },
  // {
  //   name: '',
  //   email: 'Central Board of Secondary Examinition',
  
  // },
  {
    name: 'Subjects offered in Grades 11 & 12	',
    email: '',
  
  },
  {
    name: '',
    email: 'Grade – 11 & 12 – Stream Science Combinations',
  
  },
  {
    name: '',
    email: '	English, Physics, Chemistry, Mathematics, Biology',
    
  },
  {
    name: '',
    email: '	English, Physics, Chemistry, Mathematics, Computer Science',
  
  },
  {
    name: '',
    email: 'English, Physics, Chemistry, Mathematics, Economics',
  
  },
  {
    name: '',
    email: 'English, Physics, Chemistry, Mathematics, Physical Education',
    
  },
  {
    name: '',
    email: 'English, Physics, Chemistry, Informatics Practices, Biology',
  
  },
  {
    name: '',
    email: 'English, Physics, Chemistry, Biology, Physical Education',
  
  },
  {
    name: '',
    email: 'Grade – 11 & 12 – Stream Commerce Combinations',
  
  },
  {
    name: '',
    email: '	English, Economics, Accountancy, Business Studies, Applied Mathematics',
  
  },
  {
    name: '',
    email: 'English, Economics, Accountancy, Business Studies, Informatics Practices',
  
  },
  {
    name: '',
    email: 'English, Economics, Accountancy, Business Studies, Physical Education',
  
  },


  {
    name: 'Co-curricular activities',
    email: '',
  
  },
  {
    name: '',
    email: 'School camps – Excursions/Field Trips',
  
  },
  {
    name: '',
    email: 'School Annual Day – Shikhar, Scientifica, Aagaman, Udaan  ',
  
  },
  {
    name: '',
    email: 'Inter-school Competition - Goonj ',
    
  },
  {
    name: '',
    email: 'CCA and Club activities ',
  
  },
  {
    name: '',
    email: 'Student Council led events – Teachers Day',
  
  },

  {
    name: 'Formal Official Ceremonies',
    email: '',
    
  },
  {
    name: '',
    email: '1.	Investiture Ceremony ',
    
  },
  {
    name: '',
    email: '2.	Valedictory Day ',
  
  },
  {
    name: '',
    email: '3.	Graduation Day',
  
  },
  {
    name: 'Triennial Events',
    email: '',
  
  },
  {
    name: '',
    email: 'School Annual Day – Shikhar, Scientifica, Aagaman,',
  
  },
  
  
];

const Curology = () => {
  const theme = useTheme();
  return (
    
    
    <Container>
      
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="simple table">
         
          <TableBody>
            {mock.map((item, i) => (
              <TableRow
                key={i}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  '&:nth-of-type(2n)': { bgcolor: 'alternate.main' },
                }}
              >
                <TableCell component="th" scope="row">
                  <Typography variant={'subtitle2'} fontWeight={700}>
                    {item.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  {/* <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.email}
                  </Typography> */}
                   <Typography
                    color={'text.secondary'}
                    variant={'subtitle2'}
                    align={['Grade – 11 & 12 – Stream Science Combinations', 'Grade – 11 & 12 – Stream Commerce Combinations', 'Grade – 11 & 12 – Stream Humanities Combinations'].includes(item.email) ? 'center' : 'inherit'}
                    fontWeight={['Grade – 11 & 12 – Stream Science Combinations', 'Grade – 11 & 12 – Stream Commerce Combinations'].includes(item.email) ? 700 : 'normal'}
                  >
                    {item.email}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.title}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ color: theme.palette.success.dark }}
                  >
                    {item.status}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.role}
                  </Typography>
                </TableCell>
                <TableCell>
                  {/* <Typography
                    color={'primary'}
                    variant={'subtitle2'}
                    fontWeight={700}
                    sx={{ cursor: 'pointer' }}
                  >
                    Edit
                  </Typography> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default Curology;